module.exports = __webpack_public_path__ + "img/input-light.35f4bc64.png";